// Expects a string in the format DD/MM/YYYY
export const formatDate = (value: string) => {
  const [day = '', month = '', year = ''] = value.split('/');
  return {
    day,
    month,
    year,
  };
};
